'use client';

import dynamic from 'next/dynamic';

import type { BlockComponentModel } from '@/cms/types/blok-component';

import type { ScraperStrapiProps } from './ScraperStrapi';

const ScraperStrapi = dynamic(() =>
  import('./ScraperStrapi').then((m) => m.ScraperStrapi)
);

export const ScraperLazy = (props: BlockComponentModel<ScraperStrapiProps>) => (
  <ScraperStrapi {...props} />
);
